import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import Home from './pages/Home';
import Signup from './components/Signup';
import Login from './components/Login';
import Profile from './components/Profile';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import NotFound from './pages/NotFound';
import About from './pages/About';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ProtectedRoute from './components/ProtectedRoute';
import ResetPassword from './components/ResetPassword';
import PaymentSuccess from './components/PaymentSuccess';
import { initGA, trackPageView } from './services/analytics';

// Initialize Google Analytics
initGA();

// Component to track page views
function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  
  return null;
}

function App() {
  return (
    <div className="App" style={{ 
      display: 'flex', 
      flexDirection: 'column',
      minHeight: '100vh' // This ensures the page takes at least the full viewport height
    }}>
      <NavBar />
      <div style={{ flex: 1 }}> {/* This div will grow to push the footer down */}
        <PageTracker /> {/* Add the PageTracker component */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;